<!-- 现场质控记录 -->
<template>
  <div class="doctorPage managerPlan Manager">
    <!-- 中间内容 -->
    <div class="centerHome">
      <div class="ccHomel">
        <el-row :gutter="20">
          <el-col :span="8" class="compentTable" style="padding:20px 0" v-loading="proLoading">
            <el-button type="primary" @click="addProject" round style="margin-bottom:20px;margin-left:20px">
              添加科目
            </el-button>
            <ul :style="{ height: height + 'px', overflow: 'auto', padding: '0 20px' }">
              <li class="projectLi" v-for="(item, index) in projectList" :key="index">
                <div class="title">
                  <span style="width:65%;padding:20px" @click="projectLiClick(item)">
                    {{ item.Name }}
                  </span>
                  <span class="btnCss">
                    <span @click="projectEdit(item)">
                      <svg-icon class="fz14 marr5" icon-class="icon_edit"></svg-icon>
                    </span>
                    <span @click="projectDel(item)">
                      <svg-icon class="fz14" icon-class="icon_delete"></svg-icon>
                    </span>
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
          <el-col :span="16" v-loading="listLoading">
            <div class="selectSearch" style="padding-right: 78px;">
              <el-form ref="form" :model="appealParameter" class="qcFrom" :inline="true">
                <el-form-item label="关键词">
                  <el-input
                    v-model="appealParameter.key"
                    class="name"
                    placeholder="请输入关键词"
                    size="mini"
                  ></el-input>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="appealParameter.state" placeholder="请选择状态" size="mini" class="name">
                    <el-option label="全部" :value="-1"></el-option>
                    <el-option label="启用" :value="1"></el-option>
                    <el-option label="禁用" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search" round>查询</el-button>
                  <el-button type="primary" class="resetBtn" @click="resetForm('form')">重置</el-button>
                </el-form-item>
                <el-form-item class="rightBtn">
                  <el-button type="primary" @click="addList" round style="background:#2eb4b5 !important">
                    添加
                  </el-button>
                  <!-- <el-button type="primary" class="resetBtn" @click="resetForm('form')" style="background:#2eb4b5 !important">排序</el-button> -->
                </el-form-item>
              </el-form>
            </div>
            <div class="compentTable" :style="{ height: height - 30 + 'px', overflow: 'auto' }">
              <div class="centerHome">
                <div class="ccHomel">
                  <div>
                    <el-table class="qcTable" :data="recordList" v-loading="loading">
                      <el-table-column type="index" label="序号" width="80"></el-table-column>
                      <el-table-column
                        prop="Name"
                        label="科目名称"
                        show-overflow-tooltip
                        min-width="100"
                      ></el-table-column>
                      <el-table-column prop="ViewMode" label="查看方式" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="MarkingScheme" label="扣分标准" show-overflow-tooltip></el-table-column>
                      <el-table-column
                        prop="CriterionPoint"
                        label="标准评分"
                        sortable
                        min-width="100"
                      ></el-table-column>
                      <el-table-column prop="AvailablePoint" label="本项可扣分值" min-width="120">
                        <template slot-scope="scope">
                          <div>
                            {{ JSON.stringify(scope.row.AvailablePoint).replace(/^\[|\]$/g, "") }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="State" label="状态">
                        <template slot-scope="scope">
                          <div>
                            {{ scope.row.State ? "启用" : "禁用" }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="CreatedName" label="操作人" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="CreateTime" label="操作时间" sortable min-width="160"></el-table-column>
                      <el-table-column prop="" label="操作" width="150" fixed="right">
                        <template slot-scope="scope">
                          <span class="tableOpe marr15" @click="editClick(scope.row)">编辑</span>
                          <span class="tableOpe textColorRed" @click="del(scope.row)">删除</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div class="pages">
                      <el-pagination
                        class="pageAll"
                        layout="prev, pager, next"
                        :total="totalCount"
                        :page-size="appealParameter.pageSize"
                        :current-page="appealParameter.pageIndex"
                        @current-change="currentChange"
                      ></el-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog title="添加" :visible.sync="dialogVisible" width="60%" class="dialogVisible offline">
      <el-form ref="nameProjectform" :rules="nameProject" :model="addParameter" :inline="true">
        <el-row>
          <el-col :span="12">
            <el-form-item label="科目名称" prop="Name">
              <el-input v-model="addParameter.Name" class="name" placeholder="请输入科目名称" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="扣分标准" prop="MarkingScheme">
              <el-input
                v-model="addParameter.MarkingScheme"
                class="name"
                placeholder="请输入扣分标准"
                size="mini"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态" style="width:100%">
              <el-switch v-model="state"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="查看方式" prop="ViewMode">
              <el-input
                v-model="addParameter.ViewMode"
                class="name"
                placeholder="请输入查看方式"
                size="mini"
              ></el-input>
            </el-form-item>
            <el-form-item label="标准分值" prop="CriterionPoint">
              <el-input
                v-model="addParameter.CriterionPoint"
                class="name"
                placeholder="请输入标准分值"
                type="number"
                size="mini"
                @blur="
                  (e) => {
                    blurNumber(e);
                  }
                "
              ></el-input>
            </el-form-item>
            <el-form-item label="可扣分值" prop="AvailablePoint">
              <!-- <el-input
                v-model="addParameter.AvailablePoint"
                class="name"
                placeholder="请输入本项可扣分值"
                size="mini"
              ></el-input> -->
              <el-select size="small" v-model="addParameter.AvailablePoint" placeholder="请选择可扣分值" multiple>
                <el-option v-for="item in 30" :key="item" :label="item" :value="item"></el-option>
                <el-option :key="50" :label="50" :value="50"></el-option>
                <el-option :key="100" :label="100" :value="100"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="projectAdd">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加科目" :visible.sync="projectVisible" width="40%" class="dialogVisible offline">
      <el-form ref="projectform" :model="projectParameter" :rules="rulesProject" :inline="true">
        <el-form-item label="科目名称" prop="Name">
          <el-input
            v-model="projectParameter.Name"
            class="name"
            placeholder="请输入科目名称"
            size="mini"
            max="30"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="projectVisible = false">取 消</el-button>
        <el-button type="primary" @click="projectdetermine">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Api from "../../../api";
import axios from "@/js/api";
export default {
  data() {
    return {
      nameProject: {
        Name: [
          {
            required: true,
            message: "请输入科目名称",
            trigger: "blur",
          },
        ],
        ViewMode: [
          {
            required: true,
            message: "请输入查看方式",
            trigger: "blur",
          },
        ],
        MarkingScheme: [
          {
            required: true,
            message: "请输入扣分标准",
            trigger: "blur",
          },
        ],
        CriterionPoint: [
          {
            required: true,
            message: "请输入标准分值",
            trigger: "blur",
          },
        ],
        AvailablePoint: [
          {
            required: true,
            message: "请输入标准分值",
            trigger: "change",
          },
        ],
      },
      dialogVisible: false,
      totalCount: 0,
      pages: {
        pageCount: 10,
        pageIndex: 1,
      },
      height: 0,
      appealParameter: {
        state: -1,
        key: "",
        pageSize: 10,
        pageIndex: 1,
      },
      loading: false,
      recordList: [],
      projectVisible: false,
      projectParameter: {
        Name: "",
      },
      addParameter: {
        State: 1,
        CriterionPoint: 0,
      },
      state: true,
      projectList: [],
      proLoading: false,
      listLoading: false,
      rulesProject: {
        Name: [
          {
            required: true,
            message: "请输入科目名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  activated() {
    var viewportHeight = window.innerHeight;
    this.height = viewportHeight - 240;
    this.proList(1);
  },
  methods: {
    blurNumber(e, name) {
      if (!e.target.value) {
        this.addParameter.CriterionPoint = 0;
      }
    },
    projectAdd(type) {
      let _this = this;
      this.$refs.nameProjectform.validate((valid) => {
        if (valid) {
          this.addParameter.State = this.state;
          if (this.addParameter.UniqueId) {
            axios.ajaxPost("post", Api.api.scene.criteriaDetailsEdit, this.addParameter).then((res) => {
              _this.dialogVisible = false;
              _this.criteriaList(_this.appealParameter.uid);
            });
          } else {
            this.addParameter.ScoreCriteriaUid = this.appealParameter.uid;
            this.addParameter.Sort = this.recordList.length <= 0 ? 1 : this.recordList.length + 1;
            axios.ajaxPost("post", Api.api.scene.criteriaDetailsAdd, this.addParameter).then((res) => {
              _this.dialogVisible = false;
              _this.criteriaList(_this.appealParameter.uid);
            });
          }
        } else {
          return false;
        }
      });
    },
    criteriaList(id) {
      if (id) {
        this.appealParameter.uid = id;
      }
      this.listLoading = true;
      axios.ajaxGet("get", Api.api.scene.criteriaDetailsList, this.appealParameter).then((res) => {
        this.recordList = res.data.Data;
        this.totalCount = res.data.Total;
        this.listLoading = false;
      });
    },
    projectEdit(item) {
      this.projectVisible = true;
      this.projectParameter = JSON.parse(JSON.stringify(item));
    },
    projectDel(item) {
      let _this = this;
      this.$confirm("是否确定删除科目？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          axios.ajaxPost("post", Api.api.scene.criteriaDelete, item).then((res) => {
            if (res.data.StatusCode == 200) {
              _this.$message.success("删除成功");
              _this.proList();
            } else {
              _this.$message.error(res.data.Msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    projectdetermine(type) {
      this.$refs.projectform.validate((valid) => {
        if (valid) {
          if (this.projectParameter.UniqueId) {
            axios.ajaxPost("post", Api.api.scene.criteriaEdit, this.projectParameter).then((res) => {
              this.proList();
              this.projectVisible = false;
            });
          } else {
            let sort = this.projectList.length <= 0 ? 1 : this.projectList.length + 1;
            axios
              .ajaxPost("post", Api.api.scene.criteriaAdd, {
                Name: this.projectParameter.Name,
                Sort: sort,
              })
              .then((res) => {
                this.proList();
                this.projectVisible = false;
              });
          }
        } else {
          return false;
        }
      });
    },
    proList(type) {
      this.proLoading = true;
      axios.ajaxGet("get", Api.api.scene.criteriaList).then((res) => {
        this.projectList = res.data.Data;
        this.proLoading = false;
        if (type == 1) {
          this.criteriaList(this.projectList[0].UniqueId);
        }
      });
    },
    projectLiClick(item) {
      this.appealParameter.uid = item.UniqueId;
      this.criteriaList();
    },
    // 重置
    resetForm(formName) {
      this.appealParameter = {
        state: -1,
        key: "",
        pageSize: 10,
        pageIndex: 1,
        uid: this.appealParameter.uid,
      };
      //初始化
      this.search();
    },
    //分页
    currentChange(val) {
      this.appealParameter.pageIndex = val;
      this.criteriaList(this.appealParameter.uid);
    },
    //搜索
    search() {
      //   this.appealParameter.pageSize = 10;
      this.currentChange(1);
    },
    addProject() {
      this.projectParameter = {
        Name: "",
      };
      this.projectVisible = true;
    },
    del(item) {
      let _this = this;
      this.$confirm("是否确定删除该标准？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          axios.ajaxPost("post", Api.api.scene.criteriaDetailsDel, item).then((res) => {
            if (res.data.StatusCode == 200) {
              _this.$message.success("删除成功");
              _this.criteriaList();
            } else {
              _this.$message.error(res.data.Msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    editClick(item) {
      this.dialogVisible = true;
      this.addParameter = JSON.parse(JSON.stringify(item));
    },
    addList() {
      this.dialogVisible = true;
      this.state = true;
      this.addParameter = {
        Name: "",
        MarkingScheme: "",
        State: true,
        ViewMode: "",
        CriterionPoint: 0,
        AvailablePoint: [],
        uid: this.appealParameter.uid,
      };
    },
  },
};
</script>
<style lang="scss">
	@import '@/assets/style/variables.scss';
	@import "@/assets/style/mixin.scss";
.offline .el-input__inner{
    @include bg-color(dialogareai);
    @include text-color(fzColori);
}
.rightBtn {
  position: absolute;
  right: 0;
}
.projectLi {
  // padding: 20px;
  // background: #3d4049;
  @include bg-color(htmlBg);
  border-radius: 6px;
  margin-bottom: 10px;
  .title {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .fraction {
    font-weight: 400;
    font-size: 12px;
    color: #a4a4a4;
    line-height: 12px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }
  .btnCss {
    display: flex;
    align-items: center;
    padding-right: 20px;
  }
}
</style>
